module.exports = __webpack_public_path__ + "static/media/Weber–Fechner Law.c8eff4bf.jpg";